/*=========================================================================================
  File Name: moduleUserGetters.js
  Description: User Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Useror: SpeedCodeLabs
  Useror URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  GetUser(state) {
    return state.user;
  },
  GetPolicies(state) {
    return state.policies;
  },
  GetMenuList(state) {
    var items = [
      {
        icon: 'mdi-home-circle-outline',
        'icon-alt': 'mdi-home-circle',
        text: 'Dashboard',
        link: '/',
        policy: ['Dashboard Index'],
      },
      {
        icon: 'mdi-bulletin-board',
        'icon-alt': 'mdi-bulletin-board',
        text: 'Inventory',
        policy: ['Product Index'],
        children: [
          {
            icon: 'mdi-layers-triple-outline',
            'icon-alt': 'mdi-layers-triple',
            text: 'Products',
            link: '/product',
            policy: ['Product Index'],
          },

          {
            icon: 'mdi-sack-percent',
            'icon-alt': 'mdi-account-multiple-plus',
            text: 'Sales',
            link: '/sales',
            policy: ['Sales Index'],
          },
          {
            icon: 'mdi-keyboard-return',
            'icon-alt': 'mdi-account-multiple-plus',
            text: 'Sales Return',
            link: '/sales-return',
            policy: ['Sales Index'],
          },
          {
            icon: 'mdi-file-cloud',

            text: 'Quotation',
            link: '/quotations',
            policy: ['Sales Index'],
          },

          {
            icon: 'mdi-account-multiple-outline',
            'icon-alt': 'mdi-account-multiple',
            text: 'Suppliers',
            link: '/supplier',
            policy: ['Supplier Index'],
          },
          {
            icon: 'mdi-account-convert',
            text: 'Customers',
            link: '/customer',
            policy: ['Customer Index'],
          },

          {
            icon: 'mdi-warehouse',
            'icon-alt': 'mdi-store',
            text: 'Warehouses',
            link: '/warehouse',
            policy: ['Ware House Index'],
          },

          {
            icon: ' mdi-shopping',
            text: 'Shops',
            link: '/shop',
            policy: ['Shop Index'],
          },
        ],
      },

      {
        icon: 'mdi-calendar-heart',
        text: 'Event',
        link: '/event',
        policy: ['Event Index'],
      },
      {
        icon: 'mdi-truck-check-outline',
        'icon-alt': 'mdi-truck-check',
        text: 'Purchases',
        link: '/purchases',
        policy: ['Purchase Index'],
        children: [
          {
            icon: 'mdi-storefront-outline',
            'icon-alt': 'mdi-storefront',
            text: 'Purchase Orders',
            link: '/purchase-order',
            policy: ['Purchase Order Index'],
          },
          {
            icon: 'mdi-truck-check-outline',
            'icon-alt': 'mdi-truck-check',
            text: 'Purchases',
            link: '/purchase',
            policy: ['Purchase Index'],
          },
          {
            icon: 'mdi-truck-delivery-outline',
            'icon-alt': 'mdi-truck-delivery',
            text: 'Purchase Returns',
            link: '/purchase-return',
            policy: ['Purchase Return Index'],
          },
        ],
      },
      {
        icon: 'mdi-book',
        'icon-alt': 'mdi-book-open-page-variant',
        text: 'Ledger',
        policy: ['Cash Book Index'],
        children: [
          {
            icon: 'mdi-bank',
            'icon-alt': 'mdi-bank',
            text: 'Bank',
            link: '/bank-book',
            policy: ['Bank Book Index'],
          },
          {
            icon: 'mdi-cash',
            'icon-alt': 'mdi-cash',
            text: 'Cash',
            link: '/cash-book',
            policy: ['Cash Book Index'],
          },
        ],
      },
      {
        icon: 'mdi-store',
        'icon-alt': 'mdi-store',
        text: 'Stocks',
        policy: ['Stocks Index'],
        children: [
          {
            icon: 'mdi-database',
            'icon-alt': 'mdi-database',
            text: 'Warehouse',
            link: '/stock',
            policy: ['Stocks Show'],
          },
          {
            icon: 'mdi-database-minus',
            'icon-alt': 'mdi-database',
            text: 'Shop',
            link: '/shop-stock',
            policy: ['Stocks Show'],
          },
          {
            icon: 'mdi-database-plus',
            'icon-alt': 'mdi-database-minus',
            text: 'Transfer',
            link: '/stock-transfer',
            policy: ['Transfer Index'],
          },
          {
            icon: 'mdi-home-remove',
            text: 'Damage',
            link: '/damaged-product-list',
            policy: ['Transfer Index'],
          },
          {
            icon: 'mdi-update',
            text: 'Expired',
            link: '/expired-product-list',
            policy: ['Transfer Index'],
          },
        ],
      },
      {
        icon: 'mdi-stove',
        'icon-alt': 'mdi-stove',
        text: 'Transactions',
        policy: ['Stocks Index'],
        children: [
          {
            icon: 'mdi-cash-multiple',
            text: 'Payments',
            link: '/payment',
            policy: ['Cheques Index'],
          },
          {
            icon: 'mdi-checkbook',
            text: 'Cheques',
            link: '/cheque',
            policy: ['Cheques Index'],
          },
          {
            icon: 'mdi-magnify-minus',
            text: 'Expenses',
            link: '/expenses',
            policy: ['Expense Index'],
          },
          {
            icon: 'mdi-magnify-minus-outline',
            text: 'Incomes',
            link: '/incomes',
            policy: ['Income Index'],
          },
        ],
      },
      {
        icon: 'mdi-border-all',
        'icon-alt': 'mdi-border-all',
        text: 'Master Data',
        policy: ['master'],
        children: [
          {
            icon: 'mdi-bulletin-board',
            text: 'Category',
            link: '/masterdata/category',
            policy: ['Category Index'],
          },
          {
            icon: 'mdi-chemical-weapon',
            text: 'Brand',
            link: '/masterdata/brand',
            policy: ['Brand Index'],
          },
          {
            icon: 'mdi-yeast',
            text: 'Unit',
            link: '/masterdata/unit',
            policy: ['Unit Index'],
          },
          {
            icon: 'mdi-file-document-multiple',
            text: 'Document Type',
            link: '/masterdata/documenttype',
            policy: ['Document Type Index'],
          },
          {
            icon: 'mdi-minus-network',
            text: 'Expense Category',
            link: '/masterdata/expense-category',
            policy: ['Expense Category Index'],
          },
          {
            icon: 'mdi-clipboard-plus',
            text: 'Income Category',
            link: '/masterdata/income-category',
            policy: ['Income Category Index'],
          },
          {
            icon: 'mdi-calendar-star',
            text: 'Event Type',
            link: '/masterdata/event-type',
            policy: ['Event Type Index'],
          },
          {
            icon: 'mdi-car-wash',
            text: 'Services',
            link: '/service',
            policy: ['Service Index'],
          },

          {
            icon: 'mdi-file-document',
            text: 'Documents',
            link: '/document-uploads',
            policy: ['Document Upload Index'],
          },
          {
            icon: 'mdi-file-document',
            text: 'LedgerType',
            link: '/masterdata/ledger-type',
            policy: ['Ledger Type Index'],
          },
        ],
      },

      {
        icon: 'mdi-file-document-outline',
        'icon-alt': 'mdi-file-document',
        text: 'Reports',
        link: '/reports',
        policy: ['Report Index'],
      },
      {
        icon: 'mdi-message-text-outline',
        'icon-alt': 'mdi-message-text',
        text: 'SMS',
        link: '/sms',
        policy: ['Report Index'],
      },
      {
        icon: 'mdi-wrench-outline',
        'icon-alt': 'mdi-wrench',
        text: 'Settings',
        policy: ['setting'],
        children: [
          {
            icon: 'mdi-account-circle-outline',
            text: 'Users',
            link: '/user',
            policy: ['User Index'],
          },
          {
            icon: 'mdi-account-details-outline',
            text: 'My Activities',
            link: '/setting/activicties',
            policy: ['Organization Index'],
          },
          {
            icon: 'mdi-shield-lock',
            text: 'Roles',
            link: '/role',
            policy: ['Role Index'],
          },
          {
            icon: 'mdi-cash-multiple',
            text: 'Expense Setting',
            link: '/expensesetting',
            policy: ['Expense Setting Index'],
          },
          {
            icon: 'mdi-domain',
            text: 'Organization',
            link: '/setting/organization',
            policy: ['Organization Index'],
          },
          {
            icon: 'mdi-account-key',
            text: 'Pos Setting',
            link: '/setting/pos',
            policy: ['Pos setting Index'],
          },
          {
            icon: 'mdi-keyboard-settings-outline',
            text: 'Pos Shortcuts',
            link: '/setting/pos-shortcuts',
            policy: ['Pos setting Index'],
          },
          {
            icon: 'mdi-key-variant',
            text: 'Site Configuration',
            link: '/setting/sites',
            policy: ['Site setting Index'],
          },
        ],
      },
    ];
    var itemList = [];
    items.map((item) => {
      var permission = state.user.permissions;

      var hasPermission = _.find(permission, function (permission) {
        return permission.name == item.policy;
      });

      if (hasPermission) {
        itemList.push(item);
      }
    });
    return itemList;
  },
};
